import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "@/components/ui/sonner";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Users from "@/pages/Users";
import Companies from "@/pages/Companies";
import Requests from "@/pages/Requests";
import Audit from "@/pages/Audit";
import Settings from "@/pages/Settings";
import ProtectedRoute from "@/components/ProtectedRoute";

const queryClient = new QueryClient();

const protectedRoutes: { path: string; element: JSX.Element }[] = [
  { path: "/", element: <Dashboard /> },
  { path: "/users", element: <Users /> },
  { path: "/companies", element: <Companies /> },
  { path: "/requests", element: <Requests /> },
  { path: "/audit", element: <Audit /> },
  { path: "/settings", element: <Settings /> },
];

const App = () => (
  <BrowserRouter>
    <QueryClientProvider client={queryClient}>
      <Routes>
        <Route path="/login" element={<Login />} />
        {protectedRoutes.map(({ path, element }) => (
          <Route
            key={path}
            path={path}
            element={<ProtectedRoute>{element}</ProtectedRoute>}
          />
        ))}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <Toaster />
    </QueryClientProvider>
  </BrowserRouter>
);

export default App;
